/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography } from '../typography/Typography';

const DrawerTitle = ({ centered, ornament, title, variant }) => {
  if (!ornament && !title) return null;
  const classes = classNames(
    'sui-relative sui-flex sui-items-center sui-gap-x-2',
    {
      'sui-m-auto': centered
    }
  );
  return (
    <div className={classes}>
      {ornament}
      <Typography variant={variant}>{title}</Typography>
    </div>
  );
};

DrawerTitle.displayName = 'DrawerTitle';

DrawerTitle.propTypes = {
  /**
   * Centers the contents of the title.
   */
  centered: PropTypes.bool,
  /**
   * The icon that goes before the title.
   */
  ornament: PropTypes.node,
  /**
   * The title of the drawer header.
   */
  title: PropTypes.string,
  /**
   * Variant passed to Typography, for example "h5".
   */
  variant: PropTypes.string
};

DrawerTitle.defaultProps = {
};

export { DrawerTitle };